/**
 * Утилита для работы с датами.
 * Бэкенд хранит время в UTC без суффикса Z.
 * Эта функция добавляет Z, чтобы JS правильно распознал часовой пояс.
 */
export function parseUTC(dateStr) {
  if (!dateStr) return null;
  // Уже содержит timezone (Z, +03:00, -05:00) — парсим как есть
  if (/[Zz]|[+-]\d{2}:\d{2}$/.test(dateStr)) return new Date(dateStr);
  // Дата без времени (2026-09-15) — добавляем время перед Z
  if (dateStr.length === 10) return new Date(dateStr + 'T00:00:00Z');
  // UTC без суффикса — добавляем Z
  return new Date(dateStr + 'Z');
}

/**
 * Форматировать дату для отображения (ДД.ММ.ГГГГ).
 */
export function formatDate(dateStr) {
  const d = parseUTC(dateStr);
  if (!d) return '—';
  return d.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

/**
 * Форматировать дату и время для отображения (ДД.ММ.ГГГГ ЧЧ:ММ).
 */
export function formatDateTime(dateStr) {
  const d = parseUTC(dateStr);
  if (!d) return '—';
  return d.toLocaleDateString('ru-RU', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}

/**
 * Форматировать дату с коротким месяцем (15 сент. 2026).
 */
export function formatDateShort(dateStr) {
  const d = parseUTC(dateStr);
  if (!d) return '';
  return d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' });
}

/**
 * Форматировать дату с длинным месяцем (15 сентября 2026).
 */
export function formatDateLong(dateStr) {
  const d = parseUTC(dateStr);
  if (!d) return '—';
  return d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' });
}

/**
 * Форматировать дату с длинным месяцем без года (15 сентября).
 */
export function formatDateLongNoYear(dateStr) {
  const d = parseUTC(dateStr);
  if (!d) return '';
  return d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long' });
}

/**
 * Форматировать дату и время с коротким месяцем (15 сент., 14:30).
 */
export function formatDateShortTime(dateStr) {
  const d = parseUTC(dateStr);
  if (!d) return '';
  return d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' }) + ', ' +
         d.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
}

/**
 * Форматировать "сколько времени назад".
 */
export function formatTimeAgo(dateStr) {
  const d = parseUTC(dateStr);
  if (!d) return '';
  const now = new Date();
  const diffMs = now - d;
  const diffMin = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMin < 1) return 'только что';
  if (diffMin < 60) return `${diffMin} мин назад`;
  if (diffHours < 24) return `${diffHours} ч назад`;
  if (diffDays === 1) return 'вчера';
  return `${diffDays} дн назад`;
}
